import { useLocation } from "react-router-dom";
import { useEffect } from "react";

export const ClearCouponOnRouteChange = () => {
    const location = useLocation();

    useEffect(() => {
        const allowedPaths = ["/cart/summary", "/cart/checkout"];
        if (!allowedPaths.includes(location.pathname)) {
            localStorage.removeItem("finalCouponCode");
        }
    }, [location.pathname]);

    return null;
};


